export default __webpack_public_path__ + "static/media/team-work.2be61318.svg";